import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { BaasEdgePoolError } from '../../sections/types/BaasEdgePoolError';
import { NodeID } from '../../sections/types/Node';

export interface IDeletePoolNodeParams {
  nodeId: NodeID;
  clusterId: string;
  siteId: string;
}

export interface IDeletePoolNodeResult extends IResult {
  success?: {
    nodeId: NodeID;
    displayName?: string;
    status: string;
    clusterId: string;
  };
  siteId?: string;
  error?: BaasEdgePoolError;
}

export class DeletePoolNodeRequest extends Request<IDeletePoolNodeParams, IDeletePoolNodeResult> {
  constructor(params: IDeletePoolNodeParams) {
    super('deletePoolNode', params);
  }
}
